import { Document } from "@react-pdf/renderer";
import {
  AnalysisDTO,
  AnalysisUserType,
} from "@models/platform-analysis/entities/analysis";
import { useMemo } from "react";
import { PDFPageContainer } from "../page-container";
import { AnalysisStepDTO } from "@models/platform-analysis/entities/step";
import { ProductRecommendationDTO } from "@models/platform-analysis/entities/steps/summary";
import { generatePDFPages } from "../../utils";
import { FeeSubProductDTO } from "@models/platform-analysis/entities/steps/fee";
import { FeatureAnalysisRowDTO } from "@models/platform-analysis/entities/steps/feature";
import { DisclaimerDTO } from "@models/platform-analysis/entities/disclaimer";

export const PDFDocument = ({
  userType,
  analysis,
  analysisSteps,
  productRecommendations,
  hiddenIdsIndexMap,
  disqualifiedHiddenIdsIndexMap,
  hiddenIds,
  disqualifiedHiddenIds,
  feeSubProducts,
  disqualifiedFeeSubProducts,
  featureAnalysisTableRows,
  businessMetricTableRows,
  disclaimers,
  smaTableRows,
  disqualifiedSmaTableRows,
}: {
  userType: AnalysisUserType;
  analysis: AnalysisDTO;
  analysisSteps?: AnalysisStepDTO;
  productRecommendations?: Record<string, Partial<ProductRecommendationDTO>>;
  hiddenIdsIndexMap?: boolean[];
  disqualifiedHiddenIdsIndexMap?: boolean[];
  hiddenIds?: string[];
  disqualifiedHiddenIds?: string[];
  feeSubProducts?: FeeSubProductDTO[];
  disqualifiedFeeSubProducts?: FeeSubProductDTO[];
  featureAnalysisTableRows?: FeatureAnalysisRowDTO[];
  businessMetricTableRows?: FeatureAnalysisRowDTO[];
  disclaimers?: DisclaimerDTO[];
  smaTableRows?: FeatureAnalysisRowDTO[];
  disqualifiedSmaTableRows?: FeatureAnalysisRowDTO[];
}): JSX.Element => {
  const pages = useMemo(
    () =>
      generatePDFPages({
        userType,
        analysis,
        analysisSteps,
        productRecommendations,
        hiddenIdsIndexMap,
        disqualifiedHiddenIdsIndexMap,
        hiddenIds,
        disqualifiedHiddenIds,
        feeSubProducts,
        disqualifiedFeeSubProducts,
        featureAnalysisTableRows,
        businessMetricTableRows,
        disclaimers,
        smaTableRows,
        disqualifiedSmaTableRows,
      }),
    [
      userType,
      analysis,
      analysisSteps,
      productRecommendations,
      hiddenIdsIndexMap,
      hiddenIds,
      feeSubProducts,
      featureAnalysisTableRows,
      businessMetricTableRows,
      disclaimers,
      smaTableRows,
      disqualifiedHiddenIdsIndexMap,
      disqualifiedHiddenIds,
      disqualifiedFeeSubProducts,
      disqualifiedSmaTableRows,
    ],
  );

  return (
    <Document>
      {pages?.map((page, index) => (
        <PDFPageContainer
          key={index}
          pageIndex={index}
          totalPage={pages?.length}
          isFirstPage={index === 0}
          isAppendix={page.isAppendix}
          analysis={analysis}
        >
          {page.components?.map((el, elIndex) => ({ ...el, key: elIndex }))}
        </PDFPageContainer>
      ))}
    </Document>
  );
};
